import type { ImageContent } from "@/types/report";

interface Props {
  content: ImageContent;
}

export function ImageSection({ content }: Props) {
  return (
    <div className="report-image-section">
      <img src={content.src} alt={content.alt} />
      {content.caption && <div className="caption">{content.caption}</div>}
    </div>
  );
}
